import { NgModule } from '@angular/core';
import { SuccessCenterProgressBarComponent } from './success-center-progress-bar.component';
import { CommonModule } from '@angular/common';
import { MatExpansionModule } from '@angular/material/expansion';
import { AchievementMessagePipeModule } from '../../../../modals/success-center/pipes/achievement-message-pipe/achievement-message-pipe.module';
import {  MatListModule } from '@angular/material/list';
import { RouterLink } from '@angular/router';
import {  MatTooltipModule } from '@angular/material/tooltip';
import {  MatProgressBarModule } from '@angular/material/progress-bar';

@NgModule({
  imports: [CommonModule, MatExpansionModule, AchievementMessagePipeModule, MatListModule, RouterLink, MatTooltipModule, MatProgressBarModule],
  declarations: [SuccessCenterProgressBarComponent],
  exports: [SuccessCenterProgressBarComponent],
})
export class SuccessCenterProgressBarModule { }
